import React from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from '../../elements/list/DeleteButton';
import Chart from 'chart.js';
import { MONTHS_SHORT } from "logic/constants";

export default class PushNotifications extends React.Component {

  state = {
    totalSubscribers: 3643,
    lastWeek: 223,
    lastMonth: 1068,
    lastYear: 3643
  }



  componentDidMount() {

    Chart.defaults.global.defaultFontColor = 'white';
    this.renderOrderDotsChart();

    var barChartConfig = {
      type: 'bar',
      data: {
        labels: ["8/2018", "9/2018", "10/2018", "11/2018", "12/2018", "1/2019"],
        datasets: [{
          label: '# of Votes',
          data: [400, 1000, 2500, 2300, 3000, 3250],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)'
          ],
          borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    };

    var ctx3 = document.getElementById("barChartConfig").getContext("2d");
    window.barChartConfig = new Chart(ctx3, barChartConfig);
  }

  renderOrderDotsChart() {
    var config = {
      type: 'line',
      data: {
        labels: MONTHS_SHORT,
        datasets: [{
          label: "Orders",
          data: [
            600,
            500,
            600,
            1000,
            1500,
            1200,
            1100,
            1250,
            1500,
            2000,
            1800,
            2000
          ],
          backgroundColor: 'rgba(54, 162, 235, 1)',
          borderColor: 'rgba(54, 162, 235, 0.4)',
          pointBorderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 2,
          fill: false,
          showLine: true,
          borderDash: [2],
          pointRadius: 6,
          pointHoverRadius: 10
        }]
      },
      options: {
        responsive: true,
        legend: {
          display: false,
        },
        hover: {
          mode: 'index'
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Month'
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
            ticks: {
              max: 2200,
            },
            display: true,
            scaleLabel: {
              display: false,
            }
          }]
        }
      }
    };

    var ctx = document.getElementById("chart-dots").getContext("2d");
    window.myScatter = new Chart(ctx, config);

  }

  render() {
    return (
      <div className="credit-card-management">
        <div className="main-inner">
          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header"><h3 className="widget-title"><i className="fa fa-users" aria-hidden="true"></i> Subscribers</h3></div>
            <div className="widget-inner">
              <div className="widget-new-customers">
                <i className="fa fa-users" aria-hidden="true"></i>
                <p className="customers-number">{this.state.totalSubscribers} <span>total subscribers</span></p>
                <ul>
                  <li>Last week</li>
                  <li> {this.state.lastWeek}</li>
                </ul>
                <ul>
                  <li>Last month</li>
                  <li> {this.state.lastMonth}</li>
                </ul>
                <ul>
                  <li>Last year</li>
                  <li> {this.state.lastYear}</li>
                </ul>
              </div>
              <br/>
              <Link to="/push-notifications/push-details" className="button-danger">Send Push Notification</Link>
              <Link to="/push-notifications/push-details" className="button-info">Create Customer Group</Link>

            </div>
          </div>

          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header">
              <h3 className="widget-title">
                <i className="fa fa-bar-chart" aria-hidden="true"></i> Subscriber trend
                </h3>
            </div>
            <div className="widget-inner" style={{ padding: '10px' }}>
              <div>
                <canvas id="chart-dots" style={{ width: '100%', height: '300px' }} width="600" height="300"></canvas>
              </div>
            </div>
          </div>
          <div className="widget">
            <div className="dark-blur"></div>
            <div className="widget-header">
              <h3 className="widget-title">
                <i className="fa fa-bar-chart" aria-hidden="true"></i> Messages sent
                </h3>
            </div>
            <div className="widget-inner" style={{ padding: '10px' }}>
              <div style={{ width: '100%', height: '100%' }}>
                <canvas id="barChartConfig" style={{ width: '100%', height: '300px' }} width="600" height="300"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="activated-cards">
              {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
              <div className="dark-blur"></div>
              <div className="box-header">
                <h2><i className="fa fa-users"></i> Latest Subscribers</h2>
                <div className="box-header-action">
                  <Link to="/users/all-users" className="button">List all</Link>
                </div>
              </div>
              <div className="box-body">
                <table className="table">
                  <tbody>
                    <tr className="tr-dark-bg">
                      <td style={{ width: '10%' }}>Id</td>
                      <td>Name</td>
                      <td>Customer ID</td>
                      <td>Date</td>
                      {/* <td></td> */}
                      <td align="center" style={{ width: '20%' }}>Actions</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>John Doe</td>
                      <td>165864549</td>
                      <td>12/01/2018</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="activated-cards">
              {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
              <div className="dark-blur"></div>
              <div className="box-header">
                <h2><i className="fa fa-comments"></i> Latest Pushes</h2>
                <div className="box-header-action">
                  <Link to="/users/all-users" className="button">List all</Link>
                </div>
              </div>
              <div className="box-body">
                <table className="table">
                  <tbody>
                    <tr className="tr-dark-bg">
                      <td style={{ width: '10%' }}>Id</td>
                      <td>Title</td>
                      <td>Type</td>
                      <td>Subscribers</td>
                      {/* <td></td> */}
                      <td align="center" style={{ width: '20%' }}>Actions</td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                    <tr>
                      <td>532</td>
                      <td>Activate your card!</td>
                      <td>Promotional</td>
                      <td>3620</td>
                      <td align="center">
                        <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }


  getPromotionalNotifications() {
    return (
      <div className="activated-cards">
          {/* <h1><i className="fa fa-bell" aria-hidden="true"></i> Add New Push Notifications</h1> */}
          <div className="dark-blur"></div>
          <div className="box-header">
            <h2><i className="fa fa-bell"></i> Promotional Notifications </h2>
          </div>
          <form style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '15px', position: 'relative', marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '100%' }}>
              <input type="search" style={{ maxWidth: '25%', marginRight: '20px' }} placeholder="Search" />
              <button type="submit" className="button-round width-180">Apply</button>
            </div>
            <Link to="/push-notifications/add-new"><button type="button" className="button-round width-180">Add New</button></Link>
          </form>
          <div className="box-body">
            <table className="table">
              <tbody>
                <tr className="tr-dark-bg">
                  <td style={{ width: '10%' }}>Id</td>
                  <td>Title</td>
                  <td>User Group</td>
                  <td>No. of Messages</td>
                  <td>Date</td>
                  {/* <td></td> */}
                  <td align="center" style={{ width: '20%' }}>Actions</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Message 1</td>
                  <td>10</td>
                  <td>25000</td>
                  <td>02/8/20107</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Message 2</td>
                  <td>2</td>
                  <td>100</td>
                  <td>18/7/20107</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Message 3</td>
                  <td>40</td>
                  <td>125000</td>
                  <td>12/6/20107</td>
                  <td align="center">
                    <Link to="/push-notifications/push-details" className="button-info">Details</Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/push/PushNotifications.js